import styled from 'styled-components';

import { Link } from '../Link';

export const HeaderWrapper = styled.header`
  width: 100%;
  height: auto;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 9999 !important;
  padding-top: 8px;
  box-sizing: content-box;
  opacity: ${(props) => (props.blog ? '1' : '0.98')};
  font-family: 'Lato', sans-serif;
  color: ${({ theme }) => theme.colors.gray};
  height: 75px;
  border-bottom: 1px solid #e6ecf2;

  @media (max-width: 1242px) {
    position: sticky;
    height: 75px;
  }
`;

export const MainHeader = styled.div`
  width: 100%;
  height: 100%;

  @media (max-width: 1242px) {
    overflow: hidden;
  }
`;

export const Container = styled.div`
  align-items: center;
  height: 100%;
  width: 100%;
  max-width: 1366px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0 16px;

  @media (max-width: 1242px) {
    padding: 0;
  }

  .logo {
    margin-right: 24px;
    transition: all 0.8s;

    img {
      width: 120px;
      height: 32px;
      min-width: 102px;
    }

    @media (max-width: 1242px) {
      margin: 0 auto;
    }
  }

  .mobile-logo {
    display: inline;
    position: absolute;
    left: -250px;

    @media (max-width: 1242px) {
      align-self: center;
    }
  }

  @media (max-width: 1242px) {
    width: 85%;
  }
`;

export const Login = styled(Link)`
  align-items: center;
  color: inherit;
  cursor: pointer;
  display: flex;
  font-weight: 700;
  justify-content: flex-start;
  list-style: none;
  text-decoration: none;
  background: none;
  border: none;
  font-weight: 700;
  font-size: 16px;
  font-family: 'Lato', 'sans-serif';
  border-radius: 50px;
  border: 1px solid #bcc8d6;
  padding: 12px 16px;

  ${(props) => props.$marginRight && 'margin-right: 24px;'}

  & svg {
    margin-left: 8px;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.green};
  }
`;

export const NavBar = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: 1242px) {
    overflow: hidden;
  }

  .buttonoutline {
    color: ${({ theme }) => theme.colors.green};
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    height: 2.7rem;
    letter-spacing: 0.025em;
    line-height: 21px;
    margin-right: 16px;
    text-align: center;
    white-space: nowrap;
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.green};
    border-image: initial;
    padding: 10px 24px;
    text-decoration: none;
  }

  .button {
    color: white;
    z-index: 5000;
    white-space: nowrap;
    text-align: center;
    min-width: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 12px 16px;
    align-self: center;
    height: 2.7rem;
    background-color: ${({ theme }) => theme.colors.green};
    border-radius: 32px;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0.26px;
    border: none;
    text-decoration: none;
    transition: all 0.4s;
    background-color: ${({ theme }) => theme.colors.green};

    &:hover {
      opacity: 0.8;
    }

    &:active {
      box-shadow: 0 8px 24px 0 rgba(77, 80, 98, 0.25);
      background-color: #4f7f00;
    }

    @media (max-width: 1242px) {
      width: 180px;
    }

    @media (max-width: 360px) {
      width: 140px;
    }
  }

  @media (max-width: 1242px) {
    ul {
      display: none;
    }
  }
`;

export const CTAContainer = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: 40px;

  @media (min-width: 500px) {
    margin-right: 24px;
  }
  @media (min-width: 768px) {
    margin-right: 0;
  }
`;

export const MenuItems = styled.ul`
  width: 100%;
  min-width: 380px;
  max-width: 670px;
  height: 100%;
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.51px;

  ${(props) => props.blog && 'justify-content: flex-end'}

  .active {
    color: ${({ theme }) => theme.colors.green};

    .cls-2 {
      fill: ${({ theme }) => theme.colors.green} !important;
    }
  }
`;

export const MenuItem = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  list-style: none;
  padding: 24px 16px;
  cursor: pointer;
  white-space: nowrap;

  :nth-last-child(-n + 2) {
    padding: 0;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.green};
  }

  &:hover .cls-2 {
    fill: ${({ theme }) => theme.colors.green} !important;
  }

  .dropdown {
    display: inline-block;
    position: relative;

    .dropdown-button {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      height: 100%;
      padding: 24px 16px;

      .cls-1 {
        fill: none;
      }

      .cls-2 {
        fill: ${({ theme }) => theme.colors.gray};
      }

      :hover {
        border: 1px solid #e6ecf2;
        border-radius: 24px 24px 0 0;
        border-bottom: 3px solid #fff;
      }
    }

    .dropdown-content {
      position: absolute;
      flex-direction: column;
      max-height: 0;
      top: 100%;

      &:hover ~ .dropdown-button {
        border: 1px solid #e6ecf2;
        border-radius: 24px 24px 0 0;
        border-bottom: 3px solid #fff;
      }

      width: 360px;
      transition: max-height 0.15s ease-out;
      overflow: hidden;
      background: ${({ theme }) => theme.colors.white};
      z-index: 9999;
      font-size: 14px;
      font-weight: 700;
      color: #1b1c29;
      line-height: 24px;
      letter-spacing: 0.34px;
      border-radius: 0 0 16px 16px;
      clip-path: inset(0px -10px -10px -10px);
      box-shadow: -1px 0px 0px 0px #e6ecf2 inset;
      box-shadow: 1px 0px 0px 0px #e6ecf2 inset;
      box-shadow: 0px -1px 0px 0px #e6ecf2 inset;
      box-shadow: 0px 4px 16px 0px #67748126;

      .dropdown-item {
        display: flex;
        gap: 8px;
        text-decoration: none;
        padding: 8px 20px;
        margin: 10px 0;
        color: #1b1c29;
      }

      .dropdown-item:hover {
        background-color: #f0f0f0;
      }
    }

    &:hover .dropdown-content {
      max-height: 500px;
      transition: max-height 0.25s ease-in;
    }
  }

  .active {
    color: ${({ theme }) => theme.colors.green};
  }

  a {
    color: inherit;
    text-decoration: none;
  }
`;
